import { http, URL } from "./http.service";
import { errorHandler } from "./error.service";

export const createBuy = async (bussinessId, payload) => {
  try {
    let resp = await http.post(`${URL}/buy/${bussinessId}/create`, payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const getBuys = async (businessId, params = {}) => {
  try {
    const queryString = new URLSearchParams(params).toString();
    let resp = await http.get(
      `${URL}/buy/${businessId}/get-buys?${queryString}`
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const getInventoryProducts = async (businessId) => {
  try {
    let resp = await http.get(
      `${URL}/buy/${businessId}/get-inventory-products`
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
export const updatePurchase = async (businessId, buyUuid, dataForSave) => {
  try {


    let resp = await http.put(
      `${URL}/buy/${businessId}/${buyUuid}`,
      dataForSave
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const deletePurchase = async (businessId, buyUuid) => {
  try {
    let resp = await http.delete(`${URL}/buy/${businessId}/${buyUuid}`);
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};

export const getWarehouseProducts = async (businessId) => {
  try {
    let resp = await http.get(
      `${URL}/buy/${businessId}/getAllBuyRawMatrialProducts`
    );
    return resp;
  } catch (error) {
    errorHandler(error);
  }
};
